import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { postAmendNoAdminFee } from 'src/api/amendService';
import { ProcessAmendDto } from 'src/api/amendService/dto/ProcessAmend.dto';

export const usePostAmendNoAdminFee = () =>
    useMutation<void, AxiosError, ProcessAmendDto>({
        mutationKey: ['process-amend-no-admin-fee'],
        mutationFn: (payload) => postAmendNoAdminFee(payload),
    });
